import { uploadFilesToDMS, save } from '@cogitate/ui-multi-utils';
import NProgress from 'nprogress';
import { toast } from 'react-toastify';
import { commonKeys, routeKeys } from 'ui/data/constants/keys';

export const saveForm = async (documentEditor, uploadModel, summary, props) => {
  try {
    const blob = await documentEditor.saveAsBlob('Docx');
    const binaryData = await blob.arrayBuffer();

    const uploadData = {
      size: blob.size,
      type: blob.type,
      name: uploadModel.FormName,
      binaryData: binaryData,
    };

    uploadModel.UploadedFiles = [uploadData];
    const [responseObj] = (await uploadFilesToDMS(summary, uploadModel, '', false, '', true))[0];

    if (responseObj) {
      const tempModel = JSON.parse(JSON.stringify(summary));
      const index = (tempModel.InteractiveFormPath || []).findIndex((obj) => obj.AcordCode === responseObj.acordcode);
      if (index === -1) {
        tempModel.InteractiveFormPath.push({
          AcordCode: responseObj.acordcode,
          BlobLocation: responseObj.BlobUri,
        });
      } else {
        tempModel.InteractiveFormPath[index].BlobLocation = responseObj?.BlobUri;
      }
      const updateRes = await save(
        tempModel,
        commonKeys.EmptyString,
        routeKeys.ApplicationSummary,
        commonKeys.EmptyString
      );
      toast.success('Form saved successfully.');
      await props.fetchForms(updateRes);
      props.setShow(false);
      props.handleAddRemoveOptional();
    }
    NProgress.done();
  } catch (e) {
    toast.error('Something went wrong while save the document', e);
    NProgress.done();
  }
};
